module.exports = __webpack_public_path__ + "static/media/LILogo.8cc2d3a8.svg";